import React from "react";
import { IoBookmarksOutline } from "react-icons/io5";
import { IoBookmarks } from "react-icons/io5";
import NavButton from "./NavButton";

interface DictionaryButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const DictionaryButton: React.FC<DictionaryButtonProps> = ({
  isActive,
  onClick,
}) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      icon={<IoBookmarksOutline className="h-full w-auto" />}
      fillIcon={
        <IoBookmarks className="h-full w-auto text-[var(--grey-light)]" />
      }
      text="Review"
    />
  );
};

export default DictionaryButton;
